
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[user]/[type]",
      function () {
        return require("private-next-pages/[user]/[type].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[user]/[type]"])
      });
    }
  